import { Dot } from 'lucide-react';

import { useUpdateTrialStudentAttendanceMutation } from '~entities/classes/api/update-trial-student-attendance';
import type { TrialStudent } from '~entities/student/api/get-all-trial-students';

import { cn } from '~shared/shadcn/lib/utils';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~shared/shadcn/ui/select';

export interface StatusSelectorForTrialStudentsProps {
  data: TrialStudent;
  classId: string;
  // info: CellContext<TrialStudent, unknown>;
  date: string;
}
export const StatusSelectorForTrialStudents = ({
  data,
}: StatusSelectorForTrialStudentsProps) => {
  const isPresent = data.isPresent;
  const isStudentPresent = data.isPresent === true;
  const isStudentAbsent = data.isPresent === false;
  const mutation = useUpdateTrialStudentAttendanceMutation();
  return (
    <>
      <div className='flex w-full flex-row flex-wrap gap-3'>
        <div className='min-w-[180px] flex-1'>
          <Select
            disabled={mutation.isPending}
            value={isPresent === null ? '' : isPresent ? 'present' : 'absent'}
            onValueChange={async (value) => {
              await mutation.mutateAsync({
                studentId: data._id,
                isPresent: value === 'present',
              });
            }}
          >
            <SelectTrigger
              className={cn('w-full border ring-0 focus:ring-0', {
                'border-green-400': isStudentPresent,
                'border-red-600': isStudentAbsent,
              })}
            >
              <Dot
                strokeWidth={8}
                className={cn('text-gray-400', {
                  'text-green-400': isStudentPresent,
                  'text-red-600': isStudentAbsent,
                })}
              />
              <SelectValue placeholder='Mark Attendance' />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem key={'present'} value={'present'}>
                  Present
                </SelectItem>
                <SelectItem key={'absent'} value={'absent'}>
                  Absent
                </SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </div>
      </div>
    </>
  );
};
